import { ChevronRight } from "lucide-react";

const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-sm">
    <ol className="flex flex-wrap items-center gap-1.5 text-white/70">
      <li>
        <a href="/" className="hover:text-brand-gold transition-colors">Home</a>
      </li>
      {items.map((item) => (
        <li key={item.label} className="flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5 opacity-60" />
          {item.href ? (
            <a href={item.href} className="hover:text-brand-gold transition-colors">{item.label}</a>
          ) : (
            <span aria-current="page" className="text-brand-gold">{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
